"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mail = void 0;
var mallMassageUrl = '/mail/messages';
var qs = require('qs');
exports.mail = function (axios) {
    return {
        // [Mail]
        getMailUsagesView: function (getMailUsagesView) {
            return axios.get('/mail/usages/view', getMailUsagesView);
        },
        getMailMessages: function (getMailMessages) {
            return axios.get(mallMassageUrl, getMailMessages);
        },
        getMailMessagesView: function (getMailMessagesView) {
            return axios.get(mallMassageUrl + "/view", getMailMessagesView);
        },
        // メール作成
        postMail: function (postMailRequest) {
            return axios.post("/mail?mallNo=" + postMailRequest.params.mallNo, postMailRequest.data);
        },
        // Excelアップロード
        postMailRecipientExcel: function (postMailRecipientExcelRequest) {
            var query = qs.stringify(postMailRecipientExcelRequest.params);
            return axios.post("/mail/recipient/excel?" + query, postMailRecipientExcelRequest.data);
        },
        getMailPublicAppkeyValidation: function (getMailPublicAppkeyValidationRequest) {
            return axios.get('/mail/public-appkey/validation', getMailPublicAppkeyValidationRequest);
        },
        getMailDomains: function (getMailDomainsRequest) {
            var query = qs.stringify(getMailDomainsRequest.params);
            return axios.get("/mail/domains?" + query);
        },
        getMailDomainsDkim: function (getMailDomainsDkimRequest) {
            var query = qs.stringify(getMailDomainsDkimRequest.params);
            return axios.get("/mail/domains/dkim?" + query);
        },
        putMailDomainsVerify: function (putMailDomainsVerifyRequest) {
            return axios.put('/mail/domains/verify', putMailDomainsVerifyRequest);
        },
        postMailDomains: function (postMailDomainsRequest) {
            return axios.post('/mail/domains', postMailDomainsRequest);
        },
        putMailDomainsDkimActivate: function (putMailDomainsDkimActivateRequest) {
            return axios.put('/mail/domains/dkim/activate', putMailDomainsDkimActivateRequest);
        },
        putMailDomainsDkimVerify: function (putMailDomainsDkimVerifyRequest) {
            return axios.put('/mail/domains/dkim/verify', putMailDomainsDkimVerifyRequest);
        },
        deleteMailDomains: function (deleteMailDomainsRequest) {
            var query = qs.stringify(deleteMailDomainsRequest.params);
            return axios.delete("/mail/domains?" + query);
        },
        putMailDomainsDkimDeactivate: function (putMailDomainsDkimDeactivateRequest) {
            return axios.put('/mail/domains/dkim/deactivate', putMailDomainsDkimDeactivateRequest);
        }
    };
};
